<template>
  <v-dialog v-model="dialog" max-width="500" :persistent="loading">
    <v-card>
      <v-card-title class="text-h5">
        <v-icon left color="primary">mdi-account-edit</v-icon>
        Editar Proprietário
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" @submit.prevent="save">
          <v-text-field
            v-model="user.name"
            label="Nome"
            required
            outlined
            dense
            prepend-inner-icon="mdi-account"
            :rules="[(v) => !!v || 'Nome é obrigatório']"
          />
          <v-text-field
            v-model="user.email"
            label="Email"
            required
            outlined
            dense
            prepend-inner-icon="mdi-email"
            :rules="[(v) => !!v || 'Email é obrigatório']"
          />
          <v-text-field-simplemask
            v-model="user.phone"
            label="Whatsapp"
            :properties="{
              prefix: '',
              suffix: '',
              rules: [
                (v) => !!v || 'Whatsapp é obrigatório',
                (v) => (v && v.length === 15) || 'Whatsapp inválido',
              ],
              disabled: loading,
              outlined: true,
              dense: true,
              placeholder: '',
              prependInnerIcon: 'mdi-whatsapp',
            }"
            v-bind:options="{
              inputMask: '(##) #####-####',
              outputMask: '###########',
              empty: null,
              applyAfter: false,
              alphanumeric: true,
              lowerCase: false,
            }"
          />
        </v-form>
        <v-alert v-if="error" type="error" class="mb-0">
          {{ error }}
        </v-alert>
        <v-alert v-if="success" type="success" class="mb-0">
          {{ success }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="dialog = false" :disabled="loading">
          <v-icon left>mdi-close</v-icon>
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="save"
          :loading="loading"
          :disabled="!valid"
        >
          <v-icon left>mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import adminService from "@/services/admin";

export default {
  data() {
    return {
      dialog: false,
      error: null,
      success: null,
      loading: false,
      valid: false,
      storeId: null,
      user: {
        name: "",
        email: "",
        phone: "",
      },
    };
  },
  methods: {
    open(store) {
      this.dialog = true;
      this.storeId = store.id;
      this.user = {
        name: store.owner || "",
        email: store.ownerEmail || "",
        phone: store.ownerPhone || "",
      };
      this.error = null;
      this.success = null;
    },
    async save() {
      try {
        this.loading = true;
        this.error = null;
        this.success = null;
        
        await adminService.stores.updateOwner(this.storeId, this.user);
        
        this.success = "Proprietário atualizado com sucesso!";
        this.$emit("refresh");
        
        setTimeout(() => {
          this.dialog = false;
        }, 1500);
      } catch (error) {
        this.error = error.message || "Erro ao atualizar proprietário";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.$root.$on("open-edit-owner-modal", this.open);
  },
  beforeDestroy() {
    this.$root.$off("open-edit-owner-modal", this.open);
  },
};
</script>

<style scoped>
.v-card-title {
  background: #fafafa;
  color: #424242;
  border-bottom: 1px solid #e0e0e0;
}
</style> 